module.exports = __webpack_public_path__ + "img/control_manage_img.9498c0a5.png";